import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
import { BONUS_IMGS } from '../utils/constants';
export function BonusSection() {
  const bonuses = [{
    title: '50 Giochi Veloci per Educazione Fisica',
    desc: 'Attivit\u00e0 rapide da 5 minuti perfette per attivare la classe.',
    img: BONUS_IMGS[0],
    value: '9,99 €'
  }, {
    title: '30 Lezioni Complete di Educazione Fisica',
    desc: 'Programmazione gi\u00e0 pronta da utilizzare immediatamente.',
    img: BONUS_IMGS[1],
    value: '12,99 €'
  }, {
    title: 'Schede di Valutazione Pronte da Stampare',
    desc: 'Modelli semplici e chiari per monitorare i progressi degli studenti.',
    img: BONUS_IMGS[2],
    value: '7,99 €'
  }, {
    title: '40 Percorsi Motori Creativi',
    desc: 'Percorsi dinamici per sviluppare coordinazione, equilibrio e agilit\u00e0.',
    img: BONUS_IMGS[3],
    value: '9,99 €'
  }];
  return <section className="py-16 px-4 bg-blue-900 text-white" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-29">
            Ma non &egrave; tutto.
          </h2>
          <p className="text-xl text-blue-200" data-id="element-30">
            Se accedi oggi riceverai anche 4 bonus extra completamente gratuiti.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-31">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-xl flex flex-col sm:flex-row cursor-pointer transform hover:-translate-y-1 transition-transform" onClick={scrollToOffer} data-id="element-32">
              <div className="w-full sm:w-2/5 bg-gray-50 p-4 flex items-center justify-center relative" data-id="element-33">
                <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded uppercase z-10" data-id="element-34">
                  GRATIS per oggi
                </div>
                <img src={bonus.img} alt={bonus.title} loading="lazy" className="w-full h-auto object-contain drop-shadow-md" data-id="element-35" />
              </div>
              <div className="p-6 flex-1 flex flex-col justify-center" data-id="element-36">
                <div className="flex items-center gap-2 text-orange-500 font-bold mb-2" data-id="element-37">
                  <GiftIcon className="w-5 h-5" data-id="element-38" />
                  <span data-id="element-39">BONUS {idx + 1}</span>
                </div>
                <h3 className="text-lg font-bold mb-1 leading-tight" data-id="element-40">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm mb-2" data-id="element-41">{bonus.desc}</p>
                <p className="text-sm" data-id="element-42">
                  <span className="text-gray-400 line-through" data-id="element-43">
                    Valore: {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold ml-2" data-id="element-44">GRATIS</span>
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-blue-800/50 rounded-2xl p-8 mb-10 border border-blue-700" data-id="element-45">
          <p className="text-2xl font-bold mb-2" data-id="element-46">
            In totale riceverai 9 risorse complete
          </p>
          <p className="text-blue-200" data-id="element-47">
            Un vero sistema che ti aiuter&agrave; a organizzare le lezioni in
            modo molto pi&ugrave; semplice.
          </p>
        </div>

        <div className="text-center" data-id="element-48">
          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-400 text-white font-bold text-xl py-5 px-10 rounded-full shadow-[0_8px_30px_rgb(245,158,11,0.3)] hover:shadow-[0_8px_30px_rgb(245,158,11,0.5)] transform hover:-translate-y-1 transition-all duration-300" data-id="element-49">
            S&igrave;, voglio approfittare dei bonus gratis!
          </button>
        </div>
      </div>
    </section>;
}